import {
  Button,
  Grid,
  Typography,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  TextField,
  FormControl,
  MenuItem,
} from "@mui/material";
import * as React from "react";
import { loyaltyPoints } from "../../static-models/MemberModuleData";
import useButtonStyles from "../../styles/useButtonStyles";
import { useEffect, useState } from "react";
import theme from "../../theme";
import SelectInputField from "../forms/formElements/SelectInputField";
import BasicTextField from "../forms/formElements/BasicTextField";
import { useAppSelector } from "../../redux/hooks";
import useGetLoyaltyPoints from "../../Hooks/loyaltyPoints/useGetLoyaltyPoints";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import RadioInputSection from "../forms/formElements/RadioInputSection";
import { generateExpiryDateOptions, getEncodedValue } from "../forms/utility";
import { getHashURL } from "../../util/SearchandFIlters/searchAndFilter";
import { operatorConstants } from "../../util/SearchandFIlters/Constants";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import InfiniteTable from "../Table/InfiniteScroll/InfiniteTable";
import SearchInput from "../../Shared/Components/SearchInput/SearchInput";
import {
  SearchToolTip,
  DateConstants,
  permissionsConstants,
  errorMessageConstants,
} from "../../constants/AppConstants";
import { usePermissionGetter } from "../../Hooks/Permissions/userPermissionGetter";
import { CommonButton } from "../../Shared/Components/Buttons/CommonButton";
import { constant } from "../../constants";
const transactionTypeList = ["Reward", "Redeem"];

export interface LoyaltyPointsProps {
  formData?: any;
  loyaltyPointsValue?: any;
}
export interface LoyaltyPointsFormType {
  transaction_type: String;
  points: number;
  remarks: String;
  expiry: String;
}
export const LoyaltyPoints: React.FC<LoyaltyPointsProps> = (
  props: LoyaltyPointsProps
) => {
  const { getUserPermission: getPointsPermissions } = usePermissionGetter(
    constant.domain === process.env.REACT_APP_CSA_DOMAIN
      ? permissionsConstants.member_redemption
      : permissionsConstants.members,
    permissionsConstants.points
  );
  const { loyaltyPointsValue } = props;
  const buttonStyle = useButtonStyles();
  const [disableSubmit, setDisableSubmit] = useState(true);
  const [createdBy, setCreatedBy] = useState<any>([]);
  const [filterActive, setFilterActive] = useState(false);
  const [isInitalApiCall, setIsInitalApiCall] = useState<boolean>(true);

  const searchInputRef = React.useRef<HTMLInputElement>();

  const memberDetails = useAppSelector(
    (state: any) => state.persistReducers.getMemberList?.membersList
  );

  const [loyaltyPointFormState, setLoyaltyPointFormState] =
    useState<LoyaltyPointsFormType>();
  const buttonStyles = useButtonStyles();
  const {
    getLoyaltyPoints,
    addLoyaltyPoints,
    loadingAddPoints,
    loadingGetPoints,
    data,
    showModal,
    clearForm,
    transactionTypeList,
    totalCount,
    getCustomer,
    lastKey,
    transactionTime,
  } = useGetLoyaltyPoints();



  const [isSaving, setIsSaving] = useState(false);
  const [apiData, setApiData] = useState([]);
  function getUniqueCreatedByNames(transactions: any) {
    const uniqueNames: any = [];

    transactions.forEach((transaction: any) => {
      const createdBy = transaction.createdBy;
      if (!uniqueNames.includes(createdBy)) {
        uniqueNames.push(createdBy);
      }
    });

    return uniqueNames;
  }
  // changing the api

  const bindSearchAndFilter = (canHaveExistingData?: boolean) => {
    const hashValue = {
      field: "email",
      value: canHaveExistingData
        ? encodeURIComponent(memberDetails.email)
        : memberDetails?.email,
    };

    const value = searchInputRef.current
      ? getEncodedValue(searchInputRef.current?.value)
      : "";
    const searchParam = value !== "" ? [value] : [];
    const params = {
      hashData: hashValue,
      searchData: searchParam,
      filterData: filterStates,
    };
    const url = getHashURL(params);
    const apiCall = Boolean(!canHaveExistingData);

    const lastKeyV2: any = {
      email: lastKey,
      transaction_time: transactionTime,
    };

    let urlToConact = `&lastKey=${encodeURIComponent(
      JSON.stringify(lastKeyV2)
    )}`;

    const newUrl = canHaveExistingData && lastKey ? url + urlToConact : url;
    getLoyaltyPoints(newUrl, canHaveExistingData);
    setIsInitalApiCall(false);
    return url;
  };

  useEffect(() => {
    if (isInitalApiCall) bindSearchAndFilter();
  }, [isInitalApiCall]);

  useEffect(() => {
    getCustomer(memberDetails);
  }, []);
  useEffect(() => {
    const names = getUniqueCreatedByNames(data);
    setCreatedBy(names);
    setApiData(data);
  }, [data]);
  const handleSave = async () => {
    if (validate()) {
      if (isSaving) {
        return;
      }
      setIsSaving(true);
      await addLoyaltyPoints(loyaltyPointFormState, memberDetails);
      setIsSaving(false);
      onReset();
      setOpenPoints(false);
    } else setDisableSubmit(true);
  };

  const validate = () => {
    const isValidPoints =
      loyaltyPointFormState?.points && loyaltyPointFormState.points > 0;
    const isValidRemarks =
      loyaltyPointFormState?.remarks &&
      loyaltyPointFormState.remarks.trim() !== "" &&
      loyaltyPointFormState.remarks.length < 50;

    return isValidPoints && isValidRemarks;
  };
  // new ui integration
  const handleClose = () => {
    setOpenFilter(false);
  };
  useEffect(() => {
    setDisableSubmit(!validate());
  }, [loyaltyPointFormState]);
  // integration for filters
  const [openFilter, setOpenFilter] = useState(false);
  const [openPoints, setOpenPoints] = useState(false);

  const [filterState, setFilterState] = useState({
    transactionDate: "",
    transactionType: "",
    all: false,
    reward: false,
    redeem: false,
    createdBy: "",
  });
  const onReset = () => {
    setApiData([]);
    setIsInitalApiCall(true);
  };
  const resetFilterState = () => {
    setFilterState({
      transactionDate: "",
      transactionType: "",
      all: false,
      reward: false,
      redeem: false,
      createdBy: "",
    });
    setFilterStates([]);
    setIsInitalApiCall(true);
    setFilterActive(false);
  };
  const [filterStates, setFilterStates] = useState<any>([]);

  const getAllFields = (fieldValue: any, value: any, operator?: any) => {
    const existingObject = filterStates.find(
      (obj: any) => obj.fieldValue === fieldValue
    );

    if (!existingObject) {
      setFilterStates((prev: any) => [
        ...prev,
        { fieldValue: fieldValue, value: value, operator: operator },
      ]);
    } else {
      setFilterStates((prev: any) =>
        prev.map((obj: any) =>
          obj.fieldValue === fieldValue
            ? { ...obj, value: value, operator: operator }
            : obj
        )
      );
    }
  };

  const handleApply = () => {
    setApiData([]);
    setIsInitalApiCall(true);
    setOpenFilter(false);
    filterStates.length && setFilterActive(true);
  };

  // Search integration
  const handleSearch = () => {
    setApiData([]);
    setIsInitalApiCall(true);
  };
  const handleChange = (event: SelectChangeEvent) => {
    getAllFields(
      "created_by",
      (event.target as HTMLSelectElement).value,
      operatorConstants.equal
    );
    setFilterState((prev) => ({
      ...prev,
      createdBy: event.target.value,
    }));
  };
  const handleTransactionChange = (event: SelectChangeEvent) => {
    getAllFields(
      "transaction_type",
      (event.target as HTMLSelectElement).value,
      operatorConstants.equal
    );

    setFilterState((prev) => ({
      ...prev,
      transactionType: event.target.value,
    }));
  };

  return (
    <Grid>
      <Grid sx={{ background: theme.color?.background }}>
        <Dialog
          onClose={() => {
            setOpenPoints(false);
          }}
          open={openPoints}
        >
          <Grid sx={{ width: "484px", py: 4, px: 2 }}>
            <DialogTitle
              display={"flex"}
              justifyContent={"space-between"}
              borderBottom={theme.border?.smallGrey}
            >
              <Typography
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  color: theme.color?.primary,
                  fontSize: theme.font?.fontSize.large,
                  fontWeight: theme.font?.fontWeight.thicker,
                }}
              >
                Add or Deduct Points
              </Typography>
            </DialogTitle>
            <DialogContent
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 2,
                borderBottom: theme.border?.smallGrey,
              }}
            >
              <Grid mt={2}>
                <RadioInputSection
                  setState={setLoyaltyPointFormState}
                  stateKey="transaction_type"
                  options={["Add Points", "Deduct Points"]}
                  defaultValue="Add Points"
                />
              </Grid>
              <Grid>
                <Typography
                  sx={{
                    fontFamily: theme.font?.fontFamily.primary,
                    fontSize: theme.font?.fontSize.tableBody,
                    fontWeight: theme.font?.fontWeight.slightThick,
                    color: theme.color?.newFilterGrey,
                  }}
                >
                  Point *
                </Typography>
                <BasicTextField
                  selectType={
                    loyaltyPointFormState?.transaction_type
                      ? loyaltyPointFormState.transaction_type
                      : "Points Addition"
                  }
                  loyaltyPointsValue={loyaltyPointsValue}
                  id={"points"}
                  setState={setLoyaltyPointFormState}
                  placeholder=""
                  stateKey="points"
                  required
                  align="left"
                  clear={clearForm}
                  type="number"
                  disableSubmit={setDisableSubmit}
                />
              </Grid>
              <Grid>
                {loyaltyPointFormState?.transaction_type === "Add Points" && (
                  <>
                    <Typography
                      sx={{
                        fontFamily: theme.font?.fontFamily.primary,
                        fontSize: theme.font?.fontSize.tableBody,
                        fontWeight: theme.font?.fontWeight.slightThick,
                        color: theme.color?.newFilterGrey,
                      }}
                    >
                      Expiry Date *
                    </Typography>
                    <SelectInputField
                      required
                      sx={{ width: "100%" }}
                      setState={setLoyaltyPointFormState}
                      stateKey="expiry"
                      defaultValue={generateExpiryDateOptions()[0].value}
                      align="left"
                      options={generateExpiryDateOptions().map(
                        (option) => option.display
                      )}
                    />
                  </>
                )}
              </Grid>
              <Grid mb={2}>
                <Typography
                  sx={{
                    fontFamily: theme.font?.fontFamily.primary,
                    fontSize: theme.font?.fontSize.tableBody,
                    fontWeight: theme.font?.fontWeight.slightThick,
                    color: theme.color?.newFilterGrey,
                  }}
                >
                  Remarks *
                </Typography>
                <BasicTextField
                  id={"remarks"}
                  setState={setLoyaltyPointFormState}
                  placeholder=""
                  stateKey="remarks"
                  required
                  align="left"
                  clear={clearForm}
                  errorMessage={
                    loyaltyPointFormState &&
                    loyaltyPointFormState.remarks &&
                    loyaltyPointFormState.remarks.length > 50
                      ? errorMessageConstants.remarkMessage
                      : ""
                  }
                  disableSubmit={setDisableSubmit}
                />
              </Grid>
            </DialogContent>
            <DialogActions sx={{ pr: 4, gap: 1, pt: 3 }}>
              <Button
                sx={{ ...buttonStyles.outlinedSecondary }}
                onClick={() => {
                  setOpenPoints(false);
                }}
              >
                Cancel
              </Button>
              <Button
                size="large"
                sx={{
                  ...buttonStyle.containedSecondary,
                  background: disableSubmit
                    ? theme.color?.sideGrey
                    : theme.color?.secondary,
                }}
                onClick={handleSave}
                disabled={
                  disableSubmit ||
                  isSaving ||
                  loyaltyPointFormState?.expiry === "" ||
                  loyaltyPointFormState?.points === 0 ||
                  loyaltyPointFormState?.remarks === "" ||
                  loyaltyPointFormState?.transaction_type === ""
                }
                startIcon={isSaving && <CircularProgress size={20} />}
              >
                {isSaving ? "Saving..." : "Save"}
              </Button>
            </DialogActions>
          </Grid>
        </Dialog>
        <Dialog onClose={handleClose} open={openFilter} sx={{ ml: "60vw" }}>
          <Grid sx={{ width: "484px", py: 4, px: 2 }}>
            <DialogTitle
              display={"flex"}
              justifyContent={"space-between"}
              borderBottom={theme.border?.smallGrey}
            >
              <Typography
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  color: theme.color?.primary,
                  fontSize: theme.font?.fontSize.large,
                  fontWeight: theme.font?.fontWeight.thicker,
                }}
              >
                Filter
              </Typography>
              {/* <IconButton onClick={() => setOpenFilter(false)}> */}
              <IconButton
                onClick={() => {
                  setOpenFilter(false);
                }}
              >
                <CloseOutlinedIcon />
              </IconButton>
            </DialogTitle>
            <DialogContent sx={{ borderBottom: theme.border?.smallGrey }}>
              <Grid>
                <Grid borderBottom={theme.border?.smallGrey} mt={5}>
                  <Typography
                    sx={{
                      fontFamily: theme.font?.fontFamily.primary,
                      fontSize: theme.font?.fontSize.medium,
                      fontWeight: theme.font?.fontWeight.thick,
                    }}
                  >
                    Transaction Date
                  </Typography>
                  <Grid display={"flex"} gap={2} mt={2}>
                    <TextField
                      sx={{
                        display: "flex",
                        width: "80%",
                      }}
                      type="date"
                      size="small"
                      placeholder="Transaction Date"
                      value={filterState.transactionDate}
                      onChange={(e) => {
                        getAllFields(
                          "transaction_time",
                          new Date(e.target.value).getTime(),
                          operatorConstants.equal
                        );
                        setFilterState((prev) => ({
                          ...prev,
                          transactionDate: e.target.value,
                        }));
                      }}
                      InputProps={{
                        inputProps: {
                          max: DateConstants.maxDate,
                        },
                      }}
                    />
                  </Grid>
                </Grid>
                <Grid borderBottom={theme.border?.smallGrey} mt={5}>
                  <Typography
                    sx={{
                      fontFamily: theme.font?.fontFamily.primary,
                      fontSize: theme.font?.fontSize.medium,
                      fontWeight: theme.font?.fontWeight.thick,
                    }}
                  >
                    Transaction Type
                  </Typography>
                  <Grid
                    gap={2}
                    mt={2}
                    display={"flex"}
                    sx={{
                      width: "80%",
                    }}
                  >
                    <FormControl
                      fullWidth
                      size="small"
                      sx={{
                        with: "100%",
                      }}
                    >
                      <Select
                        id=""
                        value={filterState.transactionType}
                        onChange={handleTransactionChange}
                      >
                        {transactionTypeList.map((name: any) => (
                          <MenuItem value={name}>{name}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
                <Grid borderBottom={theme.border?.smallGrey} mt={5}>
                  <Typography
                    sx={{
                      fontFamily: theme.font?.fontFamily.primary,
                      fontSize: theme.font?.fontSize.medium,
                      fontWeight: theme.font?.fontWeight.thick,
                    }}
                  >
                    Created By
                  </Typography>
                  <Grid
                    gap={2}
                    mt={2}
                    display={"flex"}
                    sx={{
                      width: "80%",
                    }}
                  >
                    <FormControl
                      fullWidth
                      size="small"
                      sx={{
                        with: "100%",
                      }}
                    >
                      <Select
                        id=""
                        value={filterState.createdBy}
                        onChange={handleChange}
                      >
                        {createdBy.map((name: any) => (
                          <MenuItem value={name}>{name}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions sx={{ pr: 4, gap: 1, pt: 3 }}>
              <Button
                sx={{ ...buttonStyles.outlinedSecondary }}
                onClick={() => {
                  resetFilterState();
                }}
              >
                Reset
              </Button>
              <Button
                sx={{ ...buttonStyles.containedSecondary }}
                onClick={handleApply}
              >
                Apply
              </Button>
            </DialogActions>
          </Grid>
        </Dialog>
        <Grid display={"flex"} justifyContent={"space-between"} px={4} py={3}>
          {getPointsPermissions("update") && (
            <CommonButton
              variant="contained"
              buttonTitle="Add/Deduct Points"
              color="secondary"
              onClick={() => {
                setOpenPoints(true);
              }}
            />
          )}

          <Grid display={"flex"} gap={3}>
            {getPointsPermissions("read") && (
              <SearchInput
                HelpTip={SearchToolTip.LoyaltyPoints}
                onCallBack={handleSearch}
                ref={searchInputRef}
              />
            )}
            {getPointsPermissions("read") && (
              <Button
                variant="text"
                startIcon={
                  filterActive ? (
                    <FilterAltIcon sx={{ color: theme.color?.secondary }} />
                  ) : (
                    <FilterAltOutlinedIcon />
                  )
                }
                sx={{ color: theme.color?.newFilterGrey }}
                onClick={() => {
                  setOpenFilter(true);
                }}
              >
                Filter
              </Button>
            )}
          </Grid>
        </Grid>
      </Grid>

      <Grid p={2}>
        {getPointsPermissions("read") && (
          <InfiniteTable
            header={loyaltyPoints.columns}
            contentItems={apiData}
            hasMoreRecords={lastKey !== null}
            fetchMoreData={() => {
              lastKey && bindSearchAndFilter(true);
            }}
            isInitialLoading={apiData.length === 0 && loadingGetPoints}
            // isInitialLoading={false}
            totalRecords={totalCount}
            lastKey={lastKey}
          />
        )}
      </Grid>
    </Grid>
  );
};
